import { restaurantsUrl, waitingtimesUrl, openingtimesUrl } from '../resources.js'

import common from '../commons/getRequest'

async function getRestaurantsByRestaurantOwner() {
    let restaurantownerid = 1;
    let url = `${restaurantsUrl}/getwithopeningtimebyrestaurantowner/${restaurantownerid}`;
    
    let data;
    try {
        await common.getData(url)
                .then(response => data = response);
        return data.restaurants;
    }
    catch (err) {
        throw err;
    }

}

async function getCurrentWaitingTimeByRestaurant(restaurantid) {

    let url = `${waitingtimesUrl}/getbyrestaurant/${restaurantid}`;
    let data;
    await common.getData(url)
                .then(response => data = response);
    return data;

}

async function getCurrentLocalTime() {
    let url = `${openingtimesUrl}/getcurrentlocaltime`;
    let data;
    await common.getData(url)
                .then(response => { 
                        data = response});
    return data;
}

export default {
    getRestaurantsByRestaurantOwner,
    getCurrentWaitingTimeByRestaurant,
    getCurrentLocalTime
}